export default {
  title: 'Ota ilmoitukset käyttöön saadaksesi eksklusiivisia tarjouksia ja päivityksiä',
  description: 'Saat tilauspäivityksiä reaaliajassa. Seuraa toimituksen tilaa. Eksklusiivisia tarjouksia ja etuja.',
  buttons: {
    confirm: 'Ota käyttöön',
    cancel: 'Ei nyt',
  },
};
